module.exports = __webpack_public_path__ + "12b47107cbb27adb8c8b1347d9852277.png";